// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import styled, { css, SimpleInterpolation } from "styled-components/macro"

const Checkbox = styled.span<{ selection: Selection }>`
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 16px;
  min-width: 16px;
  height: 16px;
  border: 1px solid ${({ theme }): string => theme.colors.gainsboro};
  background-color: ${({ theme }): string => theme.colors.white};
  border-radius: 2px;
  margin-right: 1rem;
  &:after,
  &:before {
    content: '';
    display: inline-block;
    height: 2px;
    background-color: ${({ theme }): string => theme.colors.indigo};
    position: absolute;
    top: 50%;
    margin-top: -1px;
  }
  ${({ selection }): SimpleInterpolation => {
    if (selection === "PARTIAL") {
      return css`
        &:after,
        &:before {
          width: 5px;
        }
      
        &:after {
          left: 2px;
        }
      
        &:before {
          right: 2px;
        }
      `
    }
    if (selection === "ALL") {
      return css`
        &:after,
        &:before {
          border-radius: 2px;
        }
      
        &:after {
          width: 6px;
          left: 1px;
          top: 10px;
          transform: rotate(40deg);
        }
      
        &:before {
          width: 10px;
          top: 8px;
          right: 0;
          transform: rotate(-45deg);
        }
      `
    }
    return ""
  }}
`

export type Selection = "NONE" | "PARTIAL" | "ALL"

type Props = {
  selection: Selection,
  className?: string,
  onClick?: (event: React.MouseEvent<HTMLElement>) => void,
}

const Tickbox = ({
  selection = "NONE",
  className,
  onClick,
}: Props): React.ReactElement<Props> => (
  <Checkbox selection={selection} className={className} onClick={onClick}/>
)

export default Tickbox
